import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-y', 'LetterY', [["path",{"d":"M7 4l5 9l5 -9"}],["path",{"d":"M12 13l0 7"}]]);